module.exports = __webpack_public_path__ + "img/dashu1.30da65a0.jpg";